import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { ArrowRightIcon } from 'lucide-react';
interface TreatmentCategoryProps {
  id: string;
  number: string;
  title: string;
  treatments: string[];
  image: string;
  variant: 'dark' | 'light';
  reversed?: boolean;
}
export function TreatmentCategory({
  id,
  number,
  title,
  treatments,
  image,
  variant,
  reversed = false
}: TreatmentCategoryProps) {
  const isDark = variant === 'dark';
  const bgClass = isDark ? 'bg-black' : 'bg-[#ECECEC]';
  const headlineColor = isDark ? 'text-white' : 'text-black';
  const linkColor = isDark ? 'text-white' : 'text-black';
  const linkHover = 'hover:text-[#FF1493]';
  const borderColor = isDark ? 'border-[#222222]' : 'border-[#DDDDDD]';
  const imageCol = <AnimateOnScroll className="w-full lg:w-[45%]" delay={reversed ? 200 : 0} data-id="element-2177">
      <div className="overflow-hidden shadow-lg" data-id="element-2178">
        <img src={image} alt={title} className="w-full h-[250px] sm:h-[350px] lg:h-[500px] object-cover" data-id="element-2179" />
      </div>
    </AnimateOnScroll>;
  const textCol = <AnimateOnScroll className="w-full lg:w-[55%]" delay={reversed ? 0 : 200} data-id="element-2180">
      <div className="relative" data-id="element-2181">
        {/* Decorative number */}
        <span className="text-[#FF1493] text-[48px] font-[700] font-[Poppins,_sans-serif] opacity-30 leading-none block mb-2" data-id="element-2182">
          {number}
        </span>

        <h2 className={`text-[28px] sm:text-4xl lg:text-[44px] uppercase leading-tight mb-4 font-[600] font-[Poppins,_sans-serif] ${headlineColor}`} data-id="element-2183">
          {title}
        </h2>

        <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-2184"></div>

        {/* Treatment links */}
        <div className="space-y-0" data-id="element-2185">
          {treatments.map(treatment => <a key={treatment} href={treatment === 'Wrinkle Relaxers' ? '/wrinkle-relaxers' : treatment === 'Dermal Fillers' ? '/dermal-fillers' : treatment === 'PDO Threads' ? '/pdo-threads' : treatment === 'Sculptra' ? '/sculptra' : treatment === 'Fat Dissolving Injections' ? '/fat-dissolving-injections' : treatment === 'Laser Hair Removal' ? '/laser-hair-removal' : treatment === 'SkinTyte Laser' ? '/skintyte-laser' : treatment === 'BBL' || treatment === 'BBL Forever Young + Forever Clear' ? '/bbl' : treatment === 'ClearSilk Laser Facial' ? '/clearsilk' : treatment === 'Clear + Brilliant' ? '/clear-brilliant' : treatment === 'Halo Skin Resurfacing' ? '/skin-resurfacing' : treatment === 'DiVa Vaginal Rejuvenation' ? '/vaginal-rejuvenation' : treatment === 'CoolTone' ? '/cooltone' : treatment === 'Cooltone' ? '/cooltone' : treatment === 'CoolSculpting Elite' ? '/coolsculpting-elite' : treatment === 'Weight Loss for Men' ? '/weight-loss-for-men' : treatment === 'Weight Loss for Women' ? '/weight-loss-for-women' : treatment === 'Potenza Radio Frequency Microneedling' ? '/potenza-radio-frequency-microneedling' : treatment === 'Traditional Microneedling' ? '/microneedling' : treatment === 'Chemical Peels' ? '/chemical-peels' : treatment === 'HydroPOWER Facial' ? '/hydropower-facial' : treatment === 'Korean Mesotherapy' ? '/korean-mesotherapy' : treatment === 'Dermaplaning & Waxing' ? '/dermaplaning-waxing' : treatment === 'IV Infusions & Injections' ? '/iv-infusions-injections' : treatment === 'Bioidentical Hormone Replacement Therapy' ? '/bioidentical-hormone-replacement-therapy' : treatment === 'Testosterone Replacement Therapy' ? '/testosterone-replacement-therapy-for-men' : treatment === "Ladies' Intimate Shot (O-Shot)" ? '/o-shot-for-women' : treatment === 'Performance Enhancement Shot' ? '/performance-enhancement-shot' : treatment === 'Hair Restoration for Men' ? '/hair-restoration-for-men' : '#'} className={`group flex items-center justify-between py-4 border-b ${borderColor} ${linkColor} ${linkHover} transition-all duration-300 min-h-[48px]`} data-id="element-2186">
              <span className="text-lg font-[Poppins,_sans-serif] group-hover:translate-x-1 transition-transform duration-300" data-id="element-2187">
                {treatment}
              </span>
              <ArrowRightIcon size={18} className="text-[#FF1493] flex-shrink-0 ml-3 opacity-60 group-hover:opacity-100 group-hover:translate-x-1 transition-all duration-300" data-id="element-2188" />
            </a>)}
        </div>
      </div>
    </AnimateOnScroll>;
  return <section id={id} className={`${bgClass} py-[60px] lg:py-[100px] overflow-hidden`} data-id="element-2189">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-2190">
        <div className={`flex flex-col ${reversed ? 'lg:flex-row-reverse' : 'lg:flex-row'} items-start gap-12 lg:gap-20`} data-id="element-2191">
          {imageCol}
          {textCol}
        </div>
      </div>
    </section>;
}